import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  // strategy: 'fixed' positions the menu relative to the viewport so an
  // overflow-hidden/scroll ancestor (e.g. the beta views tab row) can't
  // clip it
  static values = { strategy: String }

  connect(event) {
    const config = this.hasStrategyValue && this.strategyValue
      ? { popperConfig: { strategy: this.strategyValue } }
      : {};
    new bootstrap.Dropdown(this.element, config);
  }

  closeDropdown(event) {
    bootstrap.Dropdown.getInstance(this.element).hide();
  }

  toggleDropdown(event) {
    event.preventDefault();
    event.stopPropagation();
    bootstrap.Dropdown.getInstance(this.element).toggle();
  }

  // Close the dropdown from inside the dropdown menu
  close(event) {
    const dropdownElement = this.element.closest('.dropdown');
    if (dropdownElement) {
      const toggleButton = dropdownElement.querySelector('[data-bs-toggle="dropdown"]');
      if (toggleButton) {
        const dropdown = bootstrap.Dropdown.getInstance(toggleButton) ||
                        bootstrap.Dropdown.getOrCreateInstance(toggleButton);
        dropdown.hide();
      }
    }
  }
}
